import React from 'react';
import Footer from './Footer';
import install1 from './install1.jpg';
import install2 from './install2.jpg';
import install3 from './install3.jpg';
import install4 from './install4.jpg';

export default function ClipInstall() {
  return (
    <div className="content-page">
      <div className="content-container">
        <div className="content-hero">
          <h1>Clip Installation Guide</h1>
          <p className="page-subtitle">Step-by-step instructions for reinstalling your dendrometer clip</p>
        </div>

        <div className="content-section">
          <h2>Reattaching Your Clip</h2>
          <p>
            If your clip gets knocked off or needs repositioning, don't worry—it's easy to reattach. 
            You'll need two hands for this process.
          </p>
          <p>
            With the thumb and forefinger of one hand, pinch the black plastic body of the clip. 
            With your other hand, pinch the far end of the brass plunger rod at the spring end loop. 
            Pull these apart and the plunger will extend, allowing you to clip it back onto your plant stem.
          </p>
        </div>

        <div className="content-section">
          <h2>Optimal Stem Thickness</h2>
          <p>
            For best results, choose stems that are approximately <strong>3/16ths of an inch</strong> in diameter—
            about <strong>¾ of the clip opening</strong>. The clip requires minimum stem thickness of ⅛ inch and 
            cannot accommodate stems thicker than ¼ inch.
          </p>
        </div>

        <div className="image-gallery">
          <div className="gallery-item">
            <img src={install1} alt="Clip fell off" />
            <p className="gallery-caption">Oh no! My clip fell off.</p>
          </div>
          <div className="gallery-item">
            <img src={install2} alt="Two-hand grasp" />
            <p className="gallery-caption">Two-hand grasp: pinch body and plunger.</p>
          </div>
          <div className="gallery-item">
            <img src={install3} alt="Pull back brass plunger and place on stem" />
            <p className="gallery-caption">Pull back the brass plunger and position on stem.</p>
          </div>
          <div className="gallery-item">
            <img src={install4} alt="Correct placement" />
            <p className="gallery-caption">Correct placement on stem.</p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
